/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Guide_Cta_DescriptionInputs */

const en_directory_guide_cta_description = /** @type {(inputs: Directory_Guide_Cta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sign in to add the core product details for editorial review.`)
};

const zh_directory_guide_cta_description = /** @type {(inputs: Directory_Guide_Cta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`登录后即可填写核心产品信息，进入编辑审核流程。`)
};

/**
* | output |
* | --- |
* | "Sign in to add the core product details for editorial review." |
*
* @param {Directory_Guide_Cta_DescriptionInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_guide_cta_description = /** @type {((inputs?: Directory_Guide_Cta_DescriptionInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Guide_Cta_DescriptionInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_guide_cta_description(inputs)
	return zh_directory_guide_cta_description(inputs)
});
export { directory_guide_cta_description as "directory.guide.cta_description" }